<template>
  <div v-if="client" id="editUser" @change="dataChanged">
    <div class="tile is-ancestor">
      <div class="tile is-parent is-12">
        <article class="tile is-child box">
          <h1 class="text-h6">Edit client</h1>
          <!--          <message v-show="error" class="error-message" :title="'Error'" :container="'.styles-box'" :type="'danger'" :direction="'down'" :message=error :duration="0"></message>-->

          <div class="columns">
            <div class="column">
              <div class="block">
                <label class="label">Client name</label>
                <p class="control">
                  <input
                    v-model="data.body.name"
                    class="input"
                    type="text"
                    :class="{ 'is-danger': requiredFields['data.body.name'] }"
                    placeholder="Enter client name"
                  />
                  <!--                  <span class="help is-danger">{{validation.firstError('data.body.name')}}</span>-->
                </p>
                <label class="label">Contact name</label>
                <p class="control">
                  <input v-model="data.body.contactName" class="input" type="text" placeholder="Enter contact name" />
                </p>
                <label class="label">Contact email</label>
                <p class="control">
                  <input
                    v-model="data.body.contactEmailAddress"
                    class="input"
                    type="email"
                    :class="{ 'is-danger': requiredFields['data.body.contactEmailAddress'] }"
                    placeholder="Enter contact email"
                  />
                  <!--                  <span class="help is-danger">{{validation.firstError('data.body.contactEmailAddress')}}</span>-->
                </p>
              </div>
            </div>
          </div>

          <div class="block">
            <p class="control">
              <button class="button is-primary" :class="{ 'is-loading': isSaving }" @click="save()">Update</button>
              <button class="button is-link" @click="checkCancel()">Cancel</button>
            </p>
          </div>
        </article>
      </div>
    </div>
    <!--    <confirm-modal-->
    <!--      :visible="showModal"-->
    <!--      title="Discard your changes?"-->
    <!--      message="Any unsaved changes will be lost. Cannot undo."-->
    <!--      @confirmAction="cancel"-->
    <!--      @cancel="closeConfirmModal"-->
    <!--      @close="closeConfirmModal"-->
    <!--    >-->
    <!--    </confirm-modal>-->
  </div>
</template>

<script>
// import Message from 'vue-bulma-message'
// import ConfirmModal from '../components/modals/ConfirmModal'
import SimpleVueValidation from 'simple-vue-validator';
import { buildEndpoint } from '../../libs/buildEndPoint';
import fieldHighlights from '../../libs/forms/fieldHighlights';
import { goToPage } from '../../libs/ui/goToPage';

const { Validator } = SimpleVueValidation;

export default {
  components: {
    // Message,
    // ConfirmModal
  },

  data() {
    return {
      clientId: null,
      isSaving: false,
      showModal: false,
      client: null,
      error: null,
      unsavedChanges: null,
      data: {
        body: {
          name: '',
          contactName: '',
          contactEmailAddress: '',
        },
      },
      requiredFields: {
        'data.body.name': false,
        'data.body.contactEmailAddress': false,
      },
    };
  },

  watch: {
    // 'data.body.name' (val) {
    //   fieldHighlights.highlight(this.validation, this.requiredFields)
    // },
    // 'data.body.contactEmailAddress' (val) {
    //   fieldHighlights.highlight(this.validation, this.requiredFields)
    // }
  },

  created() {
    this.clientId = this.$route.params.clientId;
    this.get();
  },

  validators: {
    // 'data.body.name': function (value) {
    //   return Validator.value(value).required()
    // },
    // 'data.body.contactEmailAddress': function (value) {
    //   return Validator.value(value).email()
    // }
  },

  methods: {
    dataChanged() {
      this.unsavedChanges = true;
    },
    /**
     * Check for unsaved changes, show warning.
     */
    checkCancel() {
      if (this.unsavedChanges) {
        this.showModal = true;
        return;
      }
      this.cancel();
    },
    /**
     * Return to companies screen
     */
    cancel() {
      this.showModal = false;
      goToPage(this.$router, { name: 'clientDetails', params: { clientId: this.clientId } });
    },
    /**
     * Close modal, return to page.
     */
    closeConfirmModal() {
      this.showModal = false;
    },
    get() {
      this.error = null;
      this.$http
        .get(buildEndpoint('clients/get/') + this.clientId)
        .then((response) => {
          if (response.data.success) {
            this.client = response.data.data.client;
            this.data.body.name = this.client.name;
            this.data.body.contactName = this.client.contactName;
            this.data.body.contactEmailAddress = this.client.contactEmailAddress;
          } else {
            this.error = 'Error getting client data';
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },

    save() {
      this.$validate().then((success) => {
        if (success) {
          this.isSaving = true;
          this.error = null;

          const data = {
            clientId: this.clientId,
            name: this.data.body.name,
            contactName: this.data.body.contactName,
            contactEmailAddress: this.data.body.contactEmailAddress,
          };

          this.$http
            .post(buildEndpoint('clients/update'), data)
            .then((response) => {
              this.isSaving = false;
              if (response.data.success) {
                this.$router.push({ name: 'clientDetails', params: { clientId: this.clientId } });
                // all good
              } else {
                this.error = 'Error saving client data';
              }
            })
            .catch((error) => {
              this.isSaving = false;
              this.error = error;
            });
        } else {
          fieldHighlights.highlight(this.validation, this.requiredFields);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped="">
.error-message {
  margin-bottom: 20px;
}
</style>
